import React, { FunctionComponent } from "react";

import { Spinner } from "@/components/spinner";

type Props = {
  form: any;
  isSubmitting: boolean;
};
const FormSubmit: FunctionComponent<Props> = ({ form, isSubmitting }) => {
  const submitText = form.displayOptions.submitButtonText
    ? form.displayOptions.submitButtonText
    : "Submit";
  return (
    <button
      className="w-full rounded-lg bg-blue-700 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300"
      style={{
        backgroundColor: form.displayOptions.style.submitColor,
        color: form.displayOptions.style.submitFontColor,
      }}
      disabled={isSubmitting}
    >
      {isSubmitting ? (
        <>
          Sending{" "}
          <div className="inline-block h-4 w-4">
            <Spinner />
          </div>
        </>
      ) : (
        <>{submitText}</>
      )}
    </button>
  );
};

export default FormSubmit;
